export const STATUS_BG_COLORS = {
  paid: 'bg-[#A9D342]',
  awaiting_payment: 'bg-[#F59E0B]',
  pending: 'bg-[#FBBF24]',
  refused: 'bg-[#F97316]',
  not_authorized: 'bg-[#DC2626]',
  chargeback: 'bg-[#8B5CF6]',
  refunded: 'bg-[#6B7280]',
  period: 'bg-[#60A5FA]',
};

export const STATUS_COLORS = {
  paid: '#A9D342',
  awaiting_payment: '#F59E0B',
  pending: '#FBBF24',
  refused: '#F97316',
  not_authorized: '#DC2626',
  chargeback: '#8B5CF6',
  refunded: '#6B7280',
  period: '#60A5FA',
};


export const IS_PRODUCTION = window.location.origin === 'https://login.mundpay.com' || window.location.origin === 'https://login.mundpay.com';

export const PAGE_INSTRUCTIONS_URL = 'https://mundpay.crisp.help/pt-br/article/requisitos-para-aprovacao-do-site-do-seller-19to7e5/';
